import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import Home from './components/Home';
import { useHistory, useLocation } from 'react-router-dom';
import Coordinators from './components/Coordinators';
import CoordinatorView from './components/CoordinatorView';
import CoordinatorEdit from './components/CoordinatorEdit';
import CoordinatorNew from './components/CoordinatorNew';
import Customers from './components/Customers';
import CustomerView from './components/CustomerView';
import CustomerEdit from './components/CustomerEdit';
import CustomerUpgrade from './components/CustomerUpgrade';
import CustomerNew from './components/CustomerNew';
import Sales from './components/Sales';
import SalesDetail from './components/SalesDetail';

import './custom.css'
import AuthProvider from 'components/Auth/AuthProvider';
import parseHash from 'components/Auth/parseHash';
import useAuth from 'components/Auth/useAuth';

const Login = (props) => {
  const location = useLocation();
  parseHash(location, '/');

  return null;
}

const Routes = (props) => {
  const auth = useAuth();
  if (auth == null) {
    return (<Route exact path="/login" component={Login}/>);
  }

  return (
    <Layout>
      <Route exact path='/' component={Home} />
      <Route exact path='/coordinators' component={Coordinators} />
      <Route exact path='/coordinators/view/:id' component={CoordinatorView} />
      <Route exact path='/coordinators/view/:id/edit' component={CoordinatorEdit} />
      <Route exact path='/coordinators/new' component={CoordinatorNew} />
      <Route exact path='/customers' component={Customers} />
      <Route exact path='/customers/view/:id' component={CustomerView} />
      <Route exact path='/customers/view/:id/edit' component={CustomerEdit} />
      <Route exact path='/customers/view/:id/upgrade' component={CustomerUpgrade} />
      <Route exact path='/customers/new' component={CustomerNew} />
      <Route exact path='/sales/:month/:id' component={SalesDetail} />
      <Route exact path='/sales' component={Sales} />
    </Layout>
  );
}

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <AuthProvider>
        <Routes />
      </AuthProvider>
    );
  }
}
